import React from 'react';

import SpecialPagesList from 'components/SpecialPages/SpecialPagesList';

const SpecialPagesListL = props => (
  <div id="content">
    <SpecialPagesList
      {...props}
      listReduceName="specialPages.lists.specialPagesList"
    />
  </div>
);

export default SpecialPagesListL;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/SpecPages/SpecialPagesList/SpecialPagesList.js